const HolidayAllowance = (target) => {
  // * HolidayAllowanceCalculator.cshtml
  // * HolidayAllowanceController.cs

  const method = {
    init: () => {
      if (target) {
        const form = target;

        form.addEventListener("submit", function (e) {
          e.preventDefault();

          // console.log(`submitting holiday allowance calculation `);

          method.submit(form);
        });
      }
    },

    submit: async (form) => {
      const button = form.querySelector("button[type=submit]");
      const callout = form.querySelector(".callout");
      const data = new FormData(form);
      const action = form.getAttribute("action");
      const formMethod = form.getAttribute("method");

      if (callout) {
        callout.remove();
      }

      button.disabled = true;
      button.classList.add("button--loading");

      // console.log(`action `, action)
      // console.log(`method `, method)
      // console.log(`data `, data);

      fetch(action, {
        method: formMethod,
        body: data,
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.success) {
            // console.log("Calculator response");
            method.renderMessage(
              form,
              response.percentage,
              response.year,
              response.money
            );
            button.classList.remove("button--loading");
            button.disabled = false;
          } else {
            method.renderError(form, response.message, "error");
            button.classList.remove("button--loading");
            button.disabled = false;
          }
        })
        .catch((ex) => {
          console.log(ex);
          method.renderError(form, `Server error: ${ex}`, "error");
        });
    },

    renderMessage: (form, percentage, year, money) => {
      // console.log(percentage, year, money);
      const resultPercentage = form.querySelector(".js-holiday-percentage");
      const resultYear = form.querySelector(".js-holiday-year");
      const resultMoney = form.querySelector(".js-holiday-money");
      const result = form.querySelector(".js-holiday-result");

      resultPercentage.innerHTML = percentage;
      resultYear.innerHTML = year;
      resultMoney.innerHTML = money;
      result.style.display = "block";
    },

    renderError: (el, message, type) => {
      el.insertAdjacentHTML(
        "beforeend",
        `<div class="callout callout--${type}">${message}</div>`
      );
    },
  };

  method.init();
};

export default HolidayAllowance;
